<template>
  <div class="c-wholesale-form">
    <div id="nutshell-form" />
  </div>
</template>

<script>
export default {
  props: {
    formId: {
      type: String,
      default: "Yr342q",
    },
    instance: {
      type: String,
      default: "352671",
    },
  },
  data() {
    return {
      externalData: null,
      initComplete: false,
    };
  },
  mounted() {
    /* eslint-disable-next-line no-unused-vars */
    (function(n, u, t) {
      n[u] =
        n[u] ||
        function() {
          (n[u].q = n[u].q || []).push(arguments);
        };
    })(window, "Nutsheller");

    window.Nutsheller("initForm", {
      form: this.formId,
      instance: this.instance,
      target: "nutshell-form",
    });

    this.initComplete = true;
  },
  head() {
    let val = {
      script: [
        {
          id: "nutsheller-script",
          src: "https://loader.nutshell.com/nutsheller.js",
          async: true,
          defer: true,
          body: false,
        },
      ],
    };
    return this.initComplete ? val : {};
  },
};
</script>

<style lang="scss" scoped>
.c-wholesale-form {
  margin: $section-padding;
  form {
    width: 80%;
    height: 600px;
    margin: 0 auto;
    display: block;
  }
}
</style>
